/**
 * Reading the reviewable parts out of a ledger event's payload.
 *
 * `payload` is free-form JSON written by a code step inside an automation, so
 * it is typed `unknown` and must not be trusted to have any particular shape.
 * Only the three keys the approval surfaces know how to present are read;
 * anything else an automation attaches is left alone rather than rendered.
 *
 * The keys are a contract with the report steps in the API's wire-ledger
 * script: `draft` is the wording that would be sent, `asked` is what prompted
 * it, `from` is who it concerns.
 */

export interface Draft {
  draft?: string;
  asked?: string;
  from?: string;
}

export function draftFrom(payload: unknown): Draft {
  if (!payload || typeof payload !== 'object') return {};
  const record = payload as Record<string, unknown>;
  const text = (value: unknown): string | undefined =>
    typeof value === 'string' && value.trim() !== '' ? value : undefined;

  const draft = text(record['draft']);
  const asked = text(record['asked']);
  const from = text(record['from']);

  return {
    ...(draft ? { draft } : {}),
    ...(asked ? { asked } : {}),
    ...(from ? { from } : {}),
  };
}
